/*Package importing*/
import React, { Component } from 'react';
import $ from 'jquery';

/*Components*/
import devconfig from '../../config/config.js';
import APIPost from '../../services/apiCall/post';
import SignupTab1 from './signup-tab-1.js';
import SignupTab2 from './signup-tab-2.js';
import SignupTab3 from './signup-tab-3.js';
import SignupTab4 from './signup-tab-4.js';
import SignupTab5 from './signup-tab-5.js';
import GetURLVar from '../../services/getParams/get-url-var';

/*Assets*/
import Logo from '../../assets/images/logo.svg';

class Signup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tab: 1,
      type: null,
      data: null,
      error: null,
      navActive: false
    }
  }

  componentDidMount() {
    GetURLVar().then(function (query) {
      if (query.type) {
        this.setState({ tab: 5 });
      }
    }.bind(this));
    this.scrollListener();
  }

  step1Success(temp) {
    this.setState({ type: temp, tab: 2 });
    console.log(temp)
  }

  step2Success(tempData) {
    this.setState({ data: tempData });
    this.signup(tempData);
  }

  signup(tempData) {
    var url = devconfig.vendor + 'auth/signup';
    this.setState({ mail: tempData.mail, phone: tempData.phone });


    var data = JSON.stringify({
      "seller_type": this.state.type,
      "name": tempData.name,
      "email": tempData.mail,
      "company": tempData.name,
      "mobile": tempData.phone,
      "location_id": null,
      "location": tempData.locality,
      "category_ids": tempData.category,
      "address": tempData.address,
      "gst_no": tempData.gst,
      "document_url": tempData.document_url,
      "feedback": tempData.feedback
    })
    if (this.state.type != 1) {
      data = JSON.stringify({
        "seller_type": this.state.type,
        "name": tempData.name,
        "email": tempData.mail,
        "company": tempData.name,
        "mobile": tempData.phone,
        "location_id": tempData.locality.value ? tempData.locality.value : null,
        "location": tempData.locality.value ? tempData.locality.label : null,
        "department_ids": tempData.category,
        "address": tempData.address,
        "gst_no": tempData.gst,
        "document_url": tempData.document_url,
        "feedback": tempData.feedback,
        "new_location": tempData.locality.value ? null : {
          "description": tempData.newLocation.label,
          "place_id": tempData.newLocation.value,
          "reference": tempData.newLocation.value
        }
      })
    }
    APIPost(url, data).then(function (response) {
      if (response.status == "ok") {
        this.setState({ tab: 3 });
      }
      else {
        this.setState({ error: response.message });
      }
    }.bind(this))
  }

  step3Success() {
    this.setState({ tab: 4 });
  }

  scrollListener(){
    window.addEventListener('scroll', ()=>{
      var screenposition=window.innerHeight/4;

      if(window.pageYOffset<screenposition) this.setState({navActive: false});
      else if(window.pageYOffset>screenposition) this.setState({navActive: true});
    });
  }

  render() {
    return (
      <>
        <header className={this.state.navActive?"container-fluid py-4 position-fixed e-signup-header e-signup-header-active": "container-fluid py-4 position-fixed e-signup-header"}>
          <div className="container">
            <a href="https://vendor.truekhoj.com" className="e-mw-link">
              <img src={Logo} alt="Truekhoj logo" />
            </a>
          </div>
        </header>
        <section className="e-section-join-truekhoj">
          <div className="e-signup-bg-banner">
          </div>
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <h1 className="text-capitalize text-center pb-3">join truekhoj</h1>
              </div>
            </div>
            <div className="row">

              {
                this.state.tab == 1 &&
                <SignupTab1 success={this.step1Success.bind(this)} />
              }

              {
                this.state.tab == 2 &&
                <SignupTab2 success={this.step2Success.bind(this)} error={this.state.error} type={this.state.type} />
              }

              {
                this.state.tab == 3 &&
                <SignupTab3 success={this.step3Success.bind(this)} phone={this.state.phone} />
              }

              {
                this.state.tab == 4 &&
                <SignupTab4 success={this.step3Success.bind(this)} mail={this.state.mail} />
              }

              {
                this.state.tab == 5 &&
                <SignupTab5 success={this.step3Success.bind(this)} mail={this.state.mail} />
              }

            </div>
          </div>
        </section>
      </>
    );
  }
}

export default Signup;
